import { parseFormattedNumber } from "./ReporteVentasModel";

export interface ReporteMovimientosModel{
    fecha:string;
    descripcion:string;
    debe:number;
    haber:number;
    cuenta:string;
    formaPago:string;
    empleado:string
}

export const reporteMovimientosGridColumnDefinitions = {
    'FECHA': { Header: 'Fecha' },
    'DESCRIPCION': { Header: 'Descripcion' },
    'DEBE': { Header: 'Debe $', IsNumber: true },
    'HABER': { Header: 'Haber $', IsNumber: true },
    'CUENTA': { Header: 'Cuenta' },
    'FORMAPAGO': { Header: 'Forma de Pago' },
    'EMPLEADO': { Header: 'Empleado' },
};

export interface ReporteDetalleFormasPagoModel{
    formaPago: string;
    debe:number;
    haber:number;
}

export interface ReporteResumenCajaModel{
    idCaja: number;
    idLocal: number;
    pv: number;
    movimientos: ReporteMovimientosModel[];
}


export const transformReporteDeMovimientosData = (data: ReporteMovimientosModel[]): ReporteMovimientosModel[] => {
  return data.map((item) => ({
    ...item,
    debe: parseFormattedNumber(item.debe as unknown as string),
    haber: parseFormattedNumber(item.haber as unknown as string),
  }));
};